

const LockIcon = () => {
    return (
        <svg className={"svg-icon"} width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.499 15.75C13.3275 15.75 13.999 15.0784 13.999 14.25C13.999 13.4216 13.3275 12.75 12.499 12.75C11.6706 12.75 10.999 13.4216 10.999 14.25C10.999 15.0784 11.6706 15.75 12.499 15.75Z"
                fill="#0F1110"/>
            <path
                d="M20 8.25H5C4.58579 8.25 4.25 8.58579 4.25 9V19.5C4.25 19.9142 4.58579 20.25 5 20.25H20C20.4142 20.25 20.75 19.9142 20.75 19.5V9C20.75 8.58579 20.4142 8.25 20 8.25Z"
                stroke="#0F1110" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path
                d="M9.125 8.25V4.875C9.125 3.97989 9.48058 3.12145 10.1135 2.48851C10.7465 1.85558 11.6049 1.5 12.5 1.5C13.3951 1.5 14.2535 1.85558 14.8865 2.48851C15.5194 3.12145 15.875 3.97989 15.875 4.875V8.25"
                stroke="#0F1110" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export default LockIcon